import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { errMsg } from "../api";
import { toast } from "sonner";
import { BtnPrimary, Input, Label } from "../components/UI";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/");
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1758269664127-1f744a56e06c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxnYXJtZW50JTIwZmFjdG9yeSUyMHRleHRpbGUlMjByb2xsc3xlbnwwfHx8fDE3NzY2OTM5ODR8MA&ixlib=rb-4.1.0&q=85"
          alt="Garment factory"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-zinc-950/50" />
        <div className="absolute inset-0 p-12 flex flex-col justify-between text-white">
          <div>
            <div className="font-heading text-4xl font-black tracking-tighter leading-none">BE AWARA</div>
            <div className="data-label text-white/70 mt-2">Production Operating System</div>
          </div>
          <div>
            <div className="font-heading text-3xl sm:text-4xl font-bold tracking-tighter max-w-md leading-tight">
              From fabric roll to finished garment — every stage, every stitch, tracked.
            </div>
            <div className="mt-6 font-mono text-xs uppercase tracking-widest text-white/70">
              DURAKART MARKETING PVT. LTD.
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-sm">
          <div className="data-label mb-2">Sign in</div>
          <h1 className="font-heading text-3xl font-black tracking-tighter text-zinc-950 mb-8">Production Console</h1>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <Label>Email</Label>
              <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <Label>Password</Label>
              <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {err && <div className="text-sm text-red-600 border border-red-200 bg-red-50 px-3 py-2 rounded-sm" data-testid="login-error">{err}</div>}
            <BtnPrimary type="submit" disabled={loading} data-testid="login-submit-button" className="w-full">
              {loading ? "Signing in…" : "Sign in"}
            </BtnPrimary>
          </form>
        </div>
      </div>
    </div>
  );
}
